export enum TranslationTagStatus {
    Inactive = 0,
    Active = 10,
    Deleted = 20
}
